import request from "@/utils/request";



export  function  login(data:any) {
    return request({
        url: 'sys/login',
        method: 'post', 
        data,
        headers: {
          'Content-Type': 'application/json'
        }
    })
}

export  function  getCaptcha() {
  const timeStamp = new Date().getTime();
  return request({
      url: '/api/captcha?t='+timeStamp, 
      method: 'post',   
  })
}



export  function  addUser(data:any) {
    return request({
        url: 'sys/user/addUser',
        method: 'post', 
        data,
        headers: {
          'Content-Type': 'application/json'
        }
    })
}


export  function  allAdminUser(data:any) {
    return request({
        url: 'sys/allAdminUser',
        method: 'post', 
        data,
        headers: {
          'Content-Type': 'application/json'
        }
    })
}



export  function  disableUsers(data:any) {
    return request({
        url: 'sys/disableUsers',
        method: 'post', 
        data,
        headers: {
          'Content-Type': 'application/json'
        }
    })
}

export  function  allUser(data:any) {
  return request({
      url: 'sys/allUser',
      method: 'post', 
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}

export  function  modifyUserInfo(data:any) {
  return request({
      url: 'sys/modifyUserInfo',
      method: 'post', 
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}


export  function  addFengLou(data:any) {
  return request({
      url: 'sys/fengLou/addFengLou',
      method: 'post', 
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}

export  function  contactInfoFengLou(data:any) {
  return request({
      url: 'sys/fengLou/contactInfoFengLou',
      method: 'post', 
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}




export  function  allFengLou(data:any) {
  return request({
      url: 'sys/fengLou/allFengLou',
      method: 'post', 
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}



export  function  updateIsAssure(data:any) {
  return request({
      url: 'sys/fengLou/updateIsAssure',
      method: 'post', 
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}


export  function  updateFengLouState(data:any) {
  return request({
      url: 'sys/fengLou/updateFengLouState',
      method: 'post', 
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}



export  function  delFengLou(data:any) {
  return request({
      url: 'sys/fengLou/delFengLou',
      method: 'post', 
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}

export  function  reviewFengLou(data:any) {
  return request({
      url: 'sys/fengLou/reviewFengLou',
      method: 'post', 
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}




export  function  allProcessFengLou(data:any) {
  return request({
      url: 'sys/fengLou/allProcessFengLou',
      method: 'post', 
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}



 


export  function  addPayInfo(data:any) {
  return request({
      url: 'sys/payInfo/addPayInfo',
      method: 'post', 
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}

export  function  allPayInfo(data:any) {
  return request({
      url: 'sys/payInfo/allPayInfo',
      method: 'post', 
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}

export  function  delPayInfo(data:any) {
  return request({
      url: 'sys/payInfo/delPayInfo',
      method: 'post', 
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}

export  function  payInfoState(data:any) {
  return request({
      url: 'sys/payInfo/payInfoState',
      method: 'post', 
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}



export  function  addPaymentChannel(data:any) {
  return request({
      url: 'sys/paymentChannel/addPaymentChannel',
      method: 'post', 
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}


export  function  allPaymentChannel(data:any) {
  return request({
      url: 'sys/paymentChannel/allPaymentChannel',
      method: 'post', 
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}



export  function  delPaymentChannel(data:any) {
  return request({
      url: 'sys/paymentChannel/delPaymentChannel',
      method: 'post', 
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}



export  function  paymentChannelState(data:any) {
  return request({
      url: 'sys/paymentChannel/paymentChannelState',
      method: 'post', 
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}




export  function  allPayLog(data:any) {
  return request({
      url: 'sys/payLog/allPayLog',
      method: 'post', 
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}

 

export  function  allComplaint(data:any) {
  return request({
      url: '/sys/complaint/allComplaint',
      method: 'post',  
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}


export  function  modifyStatus(data:any) {
  return request({
      url: '/sys/complaint/modifyStatus',
      method: 'post',  
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}


export  function  delComplaint(data:any) {
  return request({
      url: '/sys/complaint/delComplaint',
      method: 'post',  
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}

export  function  allStatistics() {
  return request({
      url: '/sys/statistics/allStatistics',
      method: 'post',  
      headers: {
        'Content-Type': 'application/json'
      }
  })
}



export  function  setReptileSubmit(data:any) {
  return request({
      url: '/sys/config/setReptileSubmit',
      method: 'post',  
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}

 



export  function  addPlatform(data:any) {
  return request({
      url: '/sys/addPlatform',
      method: 'post',  
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}


export  function  allPlatform(data:any) {
  return request({
      url: '/sys/allPlatform',
      method: 'post',  
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}

 
export  function  delPlatform(data:any) {
  return request({
      url: '/sys/delPlatform',
      method: 'post',  
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}

 





export  function  addDomainname(data:any) {
  return request({
      url: '/sys/addDomainname',
      method: 'post',  
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}


export  function  allDomainname(data:any) {
  return request({
      url: '/sys/allDomainname',
      method: 'post',  
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}

export  function  delDomainname(data:any) {
  return request({
      url: '/sys/delDomainname',
      method: 'post',  
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}





export  function  addSysConfig(data:any) {
  return request({
      url: '/sys/addSysConfig',
      method: 'post',  
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}




export  function  getSysConfig() {
  return request({
      url: '/sys/getSysConfig',
      method: 'post',  
      headers: {
        'Content-Type': 'application/json'
      }
  })
}


 

export  function  guaranteeUsers(data:any) {
  return request({
      url: '/sys/guaranteeUsers',
      method: 'post',  
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}

 

export  function  allAccessLog(data:any) {
  return request({
      url: '/sys/allAccessLog',
      method: 'post',  
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}



export  function  delOpinion(data:any) {
  return request({
      url: '/sys/delOpinion',
      method: 'post',  
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}


export  function  allOpinion(data:any) {
  return request({
      url: '/sys/allOpinion',
      method: 'post',  
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}



export  function  replyOpinionMessage(data:any) {
  return request({
      url: '/sys/replyOpinionMessage',
      method: 'post',  
      data,
      headers: {
        'Content-Type': 'application/json'
      }
  })
}







